<template>
  <div>
    <div @click="openDialog">
      <slot></slot>
    </div>
    <el-dialog :visible.sync="dialogVisible" append-to-body custom-class="take-dialog" width="340px">
      <div v-if="dialogType == 1" slot="title" class="dialog-title">选择{{ type == 5 ? '设计单' : '复诊卡'}}</div>
      <div v-if="dialogType == 2" slot="title" class="dialog-title">选择模板 <span>新建的设计单模板</span></div>
      <template v-if="dialogType == 1">
        <div class="add-design-btn black-14" @click="addNewCard">+ 新建{{ type == 5 ? '设计单' : '复诊卡'}}</div>
        <div class="design-list-warp">
          <div v-if="loadStatus == 'load'" class="load-info"><i class="el-icon-loading"></i>加载中</div>
          <div v-for="item in list" :key="item.id"
               :class="select_card.id == item.id ? 'design-list-on' : ''"
               class="design-list d-flex-between"
               @click="designListChoose(item)">
            <div class="black-14">{{ item.type_name }} {{ item.card_date }}</div>
            <div class="iconfont icon-yulan" @click.stop="showDesignCard(item.id)"></div>
          </div>
        </div>
        <div class="take-dialog-bottom">
          <div class="take-dialog-close" @click="dialogVisible = false">取消</div>
          <div class="take-dialog-open" @click="confirmChoose">确定</div>
        </div>
      </template>
      <template v-if="dialogType == 2">
        <div class="d-flex-between">
          <div v-for="item in designModel" class="design-item">
            <div :class="designType.id == item.id? 'design-item-on':''" class="design-item-img">
              <!--                  <img :src="item.item_comment" alt="">-->
              <el-image
                  :preview-src-list="[item.item_comment]"
                  :src="item.item_comment">
              </el-image>
              <div class="design-item-cover" @click="designType = item"></div>
              <div class="design-item-eye">
                <i class="iconfont icon-yulan"></i>
              </div>
            </div>
            <div class="design-item-name" @click="designType = item">
              <div :class="designType.id == item.id? 'icon-yixuan':'icon-weixuan'" class="iconfont"></div>
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="take-dialog-bottom">
          <div class="take-dialog-close" @click="dialogVisible = false">取消</div>
          <div :class="designType.id ? '' : 'disClick'" class="take-dialog-open" @click="openAddDesign">确定</div>
        </div>
      </template>

    </el-dialog>

  </div>
</template>

<script>
import {search} from "@/http/card";
import {GetCaseInfo, GetListByTypeCode} from "@/http/api";

export default {
  name: "DesignCard",
  props: {
    patient_id: {
      type: Number,
      default: null,
    },
    openDrawer: {
      type: Function,
      default: null
    },
    isFit: {
      type: Boolean
    },
    type:null
  },
  watch: {
    patient_id: {
      handler: function (val, oldVal) {
        if (val != oldVal) {
          this.list = []
          this.$emit('designCardData', {})
          this.getList()
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      select_card: {},
      //弹窗类型，1为选择设计单，2为选择设计模板
      dialogType: 1,
      designModel: [],
      designType: {},
      loadStatus: '',
      member: JSON.parse(localStorage.getItem('member')),
    };
  },
  mounted() {
    GetListByTypeCode({type_code: ['shejidanmoban']}).then(res => {
      this.designModel = res.data.shejidanmoban
    })
  },
  methods: {
    getList() {
      console.log(this.patient_id)
      if (this.patient_id) {
        this.loadStatus = 'load'
        var params = {
          patient_id: this.patient_id,
          type_id: this.type,
        };
        this.loading = true;
        search(params).then((res) => {
          this.list = res.data.data;
          this.loading = false;
          this.loadStatus = ''
        });
      } else {
        this.list = []
      }
    },
    openDialog() {
      if (this.isFit && !this.patient_id) {
        this.$message({
          type: 'info',
          message: '请先选择匹配的病例'
        })
      } else {
        this.dialogVisible = true
        this.dialogType = 1
        this.list = []
        this.getList()
        // if(this.type == 2){
        //
        // }
      }
    },
    openAddDesign() {
      this.dialogVisible = false
      this.dialogType = 1
      this.$emit('designModel', this.designType)
      this.openDrawer()
    },
    designListChoose(item) {
      this.select_card = item
    },
    confirmChoose() {
      this.dialogVisible = false
      this.$emit('designCardData', this.select_card)
    },
    addNewCard(){
      if(this.type == 5){
        this.dialogType = 2
      }else{
        this.dialogVisible = false
        let url = this.$router.resolve({
          name: '新增资料卡',
          query: {
            name: '复诊卡',
            id: this.patient_id,
          }
        })
        window.open(url.href, '_blank')
      }
    },
    showDesignCard(id) {
      if(this.member.member_type == 1){
        GetCaseInfo({id:this.patient_id}).then(res=>{
          let openUrl = this.$router.resolve({
            name:'病历管理',
            query:{
              doctor_id:res.data.doctor_id,
              id:this.patient_id,
              card_id:id
            }
          })
          window.open(openUrl.href,'_blank')
        })
      }else{
        let openUrl = this.$router.resolve({
          name:'病历管理',
          query:{
            id:this.patient_id,
            card_id:id
          }
        })
        window.open(openUrl.href,'_blank')
      }

    },
  },
};
</script>
<style scoped src="../../../../assets/css/case_management.css"></style>
<style scoped>
.add-design-btn {
  cursor: pointer;
  height: 44px;
  text-align: center;
  line-height: 44px;
  margin-bottom: 15px;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
}

.design-list-warp {
  overflow-y: auto;
  max-height: 400px;
}

.design-list {
  margin-bottom: 5px;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
  height: 40px;
  border-radius: 8px;
}

.design-list .black-14 {
  font-weight: 500;
}

.design-list .icon-yulan {
  color: #8f8f8f;
}

.design-list-on {
  border: 1px solid #fed400;
  background: rgba(254, 212, 0, 0.05);
}
</style>
